import { useState } from "react";
import { Fish } from "lucide-react";
import "@/App.css";
import { loadData } from "@/data/seed";
import { Login } from "@/components/Login";
import { Modal } from "@/components/Common";
import { Sidebar, Topbar } from "@/components/Layout";
import { CatchForm } from "@/components/CatchForm";
import Dashboard from "@/pages/Dashboard";
import TableModule from "@/pages/TableModule";
import Prices from "@/pages/Prices";
import Reports from "@/pages/Reports";

function App() {
  const [user, setUser] = useState(() => localStorage.getItem("sipikan-user"));
  const [module, setModule] = useState("dashboard");
  const [data, setData] = useState(loadData);
  const [modal, setModal] = useState(null);

  const login = (role) => { localStorage.setItem("sipikan-user", role); setUser(role); };
  const logout = () => { localStorage.removeItem("sipikan-user"); setUser(null); };
  const saveData = (next) => { setData(next); localStorage.setItem("sipikan-data", JSON.stringify(next)); };
  const addCatch = (e) => {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    const entry = { id: Date.now(), date: new Date().toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }), species: f.get("species"), vessel: f.get("vessel"), weight: Number(f.get("weight")), value: Number(f.get("value")), zone: "WPP 573" };
    saveData({ ...data, catches: [entry, ...data.catches] });
    setModal(null);
  };

  if (!user) return <Login onLogin={login} />;
  return <div className="app-shell">
    <Sidebar user={user} module={module} setModule={setModule} onLogout={logout} />
    <main className="main-content">
      <Topbar module={module} />
      <div className="page-content">
        {module === "dashboard" && <Dashboard data={data} setModule={setModule} />}
        {["catches", "vessels", "auctions"].includes(module) && <TableModule type={module} data={data} openModal={(type, row) => setModal({ type, row })} />}
        {module === "prices" && <Prices data={data} />}
        {module === "reports" && <Reports data={data} />}
      </div>
    </main>
    {modal && <Modal title={modal.type === "catches" ? "Tambah catatan tangkapan" : "Data sedang dipersiapkan"} onClose={() => setModal(null)}>
      {modal.type === "catches" ? <CatchForm onSubmit={addCatch} /> : <div className="empty-modal"><Fish size={30} /><p>Formulir modul ini siap dikembangkan pada tahap berikutnya.</p><button className="secondary" onClick={() => setModal(null)} data-testid="modal-ok-button">Tutup</button></div>}
    </Modal>}
  </div>;
}

export default App;
